import React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { TiptapReadOnlyContent } from "../../../../component/tiptapEditor"
import PaperQuestionStem from "../../PracticePapers/components/PaperQuestionStem"
import type { PaperQuestionState } from "../../PracticePapers/types"
import { hasAnswerContent } from "../../PracticePapers/utils/hasAnswerContent"
import QuestionFeedback from "./QuestionFeedback"
import "./AssessmentCard.style.scss"

interface PaperQuestionDetailProps {
  index: number
  total: number
  question: PaperQuestionState
  onPrev: () => void
  onNext: () => void
}

const PaperQuestionDetail = ({
  index,
  total,
  question,
  onPrev,
  onNext,
}: PaperQuestionDetailProps) => (
  <article className="assessment-card paper-assessor__detail">
    <header className="assessment-card__header">
      <div className="assessment-card__chips">
        <span className="assessment-card__chip is-question">Q{index + 1}</span>
        {question.topic && (
          <span className="assessment-card__chip">{question.topic}</span>
        )}
      </div>
      <span className="assessment-card__date">
        {question.score ?? "—"}/{question.maxScore}
      </span>
    </header>

    <div className="assessment-card__body">
      <PaperQuestionStem
        html={question.questionText}
        artifacts={question.questionArtifacts}
      />
      <div className="assessment-card__answer">
        <span>Your answer</span>
        {hasAnswerContent(question.answerText) ? (
          <TiptapReadOnlyContent html={question.answerText} />
        ) : (
          <p>
            <i>No answer provided</i>
          </p>
        )}
      </div>
    </div>

    <QuestionFeedback
      criteria={question.criteriaBreakdown}
      strengths={question.strengths}
      improvements={question.improvements}
      suggestedAnswer={question.suggestedAnswer}
      examinerFeedback={question.examinerFeedback}
    />

    <div className="paper-assessor__nav">
      <button type="button" onClick={onPrev} disabled={index === 0}>
        <ChevronLeft size={16} /> Previous
      </button>
      <span>
        {index + 1} of {total}
      </span>
      <button type="button" onClick={onNext} disabled={index >= total - 1}>
        Next <ChevronRight size={16} />
      </button>
    </div>
  </article>
)

export default PaperQuestionDetail
